<div class="container_dialog" data-testid="import-error-dialog">
    <div class="header_popup">
        <div class="title_popup">
            <span>{{ 'import.LINE_CONTENT' | translate }}</span>
        </div>
        <button class="close_btn" (click)="close()">
            <img src="assets/icones/close.svg" alt="">
        </button>
    </div>
    <div class="body_popup">
        <table>
            <tr>
                <th *ngFor="let key of objectKeys(data.rowsErrorsResponse.products[0])">{{ key }}</th>
            </tr>
            <ng-container *ngIf="data.error.message">
                <tr>
                    <td *ngFor="let key of objectKeys(data.rowsErrorsResponse.products[data.error.rows.from])" [ngClass]="{'highlight_field': key === getFieldIndex(data.error.field)}">{{data.rowsErrorsResponse.products[data.error.rows.from][key]}}</td>
                </tr>
                <tr>
                    <td class="error_message_field" *ngFor="let key of objectKeys(data.rowsErrorsResponse.products[data.error.rows.from])">
                        <span *ngIf="key === getFieldIndex(data.error.field)">{{data.error.message}}</span>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="data.error.messages">
                <ng-container *ngFor="let record of data.error.records, let i = index">
                    <tr>
                        <td *ngFor="let key of objectKeys(data.rowsErrorsResponse.products[record])" [ngClass]="{'highlight_field': key === getFieldIndex(data.error.field)}">{{data.rowsErrorsResponse.products[record][key]}}</td>
                    </tr>
                    <tr>
                        <td class="error_message_field" *ngFor="let key of objectKeys(data.rowsErrorsResponse.products[data.error.rows.from])">
                            <span *ngIf="key === getFieldIndex(data.error.field)">{{data.error.messages[i]}}</span>
                        </td>
                    </tr>
                </ng-container>
    
            </ng-container>
        </table>
    </div>
    <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">{{'common.CANCEL' | translate}}</button>
    </div>
</div>